// Helper function to handle fetch responses like axios
const handleResponse = async response => {
  const data = await response.json();
  if (!response.ok) {
    const error = new Error('API request failed');
    error.response = { data };
    throw error;
  }
  return { data }; // Match axios response structure
};

/**
 *
 * @param clientUrl
 * @returns {Promise<any>}
 */
export function postSnowflakeParseURL(clientUrl) {
  const url = '/datalake/snowflake/parse_url';
  const obj = {
    snowflake_url: clientUrl,
  };
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  }).then(handleResponse);
}

/**
 *
 * @param account_id
 * @param cloud
 * @param region
 * @param client_url
 * @returns {Promise<any>}
 */
export function postSnowflakeInit(account_id, cloud, region, client_url) {
  const url = '/datalake/snowflake/setup/initialize';
  const obj = {
    client_account_id: account_id,
    client_cloud: cloud,
    client_snowflake_region: region,
    client_url,
  };
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  }).then(handleResponse);
}

/**
 *
 * @param selectedReport
 * @param tableName
 * @param identifier [OPT]
 * @returns {Promise<any>}
 */
export function postSnowflakeTable(selectedReport, tableName, identifier = '') {
  const url = '/datalake/snowflake/table';
  const obj = {
    report: selectedReport,
    identifier,
    table_name: tableName,
  };
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  }).then(handleResponse);
}

/**
 *
 * @param region
 * @returns {Promise<any>}
 */
export function postRedshiftInit(region) {
  const url = '/datalake/redshift/setup/initialize';
  const obj = {
    client_redshift_region: region,
  };
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  }).then(handleResponse);
}

/**
 *
 * @param iamRoleArn
 * @returns {Promise<any>}
 */
export function postRedshiftGrantPermission(iamRoleArn) {
  const url = '/datalake/redshift/setup/grant_permission';
  const obj = {
    client_iam_role: iamRoleArn,
  };
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  }).then(handleResponse);
}

export function postRedshiftTable(selectedReport, tableName, identifier = '') {
  const url = '/datalake/redshift/table';
  const obj = {
    report: selectedReport,
    identifier,
    table_name: tableName,
  };
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  }).then(handleResponse);
}

/**
 *
 * @returns {Promise<any>}
 */
export function getDatalakeReports() {
  const url = '/datalake/schemas/';
  return fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

/**
 *
 * @returns {Promise<any>}
 */
export function getDatalakeTables() {
  const url = '/datalake/table';
  return fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

export function getDatalakeConnectionByAdvertiser() {
  const url = '/datalake/connection';
  return fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}

// BigQuery
export const postGCPSetup = ({ region, projectId, datasetId }) => fetch('/datalake/bigquery/setup/initialize', {
  credentials: 'include',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    region,
    project_id: projectId,
    dataset_id: datasetId,
  }),
}).then(handleResponse);

export const postEmailToPermissions = (email, entity_type) => fetch('/datalake/bigquery/setup/permissions', {
  credentials: 'include',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    email,
    entity_type,
  }),
}).then(handleResponse);

export const getPermissionsList = role => fetch(`/datalake/bigquery/setup/permissions?role=${role}`, {
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}).then(handleResponse);

/**
 * TODO: Since the platform has been renamed in the API to: gcp, we should rename the route
 * */
export const postBigQueryTable = (report_name, table_name, identifier = '') => fetch('/datalake/bigquery/table', {
  credentials: 'include',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    table_name,
    report_name,
    identifier,
  }),
}).then(handleResponse);
